if (!customElements.get('dtc-product-form')) {
  customElements.define('dtc-product-form', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.selector = this.form?.querySelector('[data-dtc-variant]');
      this.button = this.form?.querySelector('[data-dtc-main-cta]');
      this.error = this.querySelector('[data-error]');
      this.selector?.addEventListener('change', () => this.sync(true));
      this.form?.addEventListener('submit', e => this.submit(e));
      this.querySelectorAll('[data-yuna-qty]').forEach(button => button.addEventListener('click', () => {
        const input = this.form.querySelector('[name=quantity]');
        const current = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = Math.max(1, current + Number(button.dataset.yunaQty));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      this.sync(false);
    }
    sync(updateUrl) {
      const option = this.selector?.selectedOptions[0];
      if (!option || !this.button) return;
      this.available = option.dataset.available === 'true';
      this.button.disabled = !this.available || !!this.pending;
      this.button.querySelector('span').textContent = this.available ? this.dataset.addLabel : this.dataset.soldOut;
      this.button.querySelector('[data-price]').textContent = option.dataset.price;
      this.querySelector('[data-dtc-stock-help]').hidden = this.available;
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
        if (option.dataset.image) {
          const gallery=this.closest('section').querySelector('[data-dtc-gallery]');
          if(gallery?.showImage)gallery.showImage(option.dataset.image);
          else {const image=gallery?.querySelector('.dtc-gallery__stage img');if(image){image.removeAttribute('srcset');image.src=option.dataset.image;}}
        }
      }
      document.dispatchEvent(new CustomEvent('dtc:variant-change', { detail: { available: this.available, price: option.dataset.price, label: this.button.querySelector('span').textContent }}));
    }
    async submit(e) {
      if (this.dataset.ajax !== 'true') return;
      e.preventDefault();
      if (this.pending || !this.available || !this.form.reportValidity()) return;
      this.pending = true;
      this.button.disabled = true;
      this.error.textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const formData = new FormData(this.form);
        if (window.YunaCart) {
          formData.set('sections', window.YunaCart.sectionId);
          formData.set('sections_url', root);
        }
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        this.pending = false;
        this.sync(false);
        if (window.YunaCart) await window.YunaCart.open(result.sections);
        else location.assign(root + 'cart');
      } catch (error) {
        this.error.textContent = error.message;
        this.pending = false;
        this.sync(false);
      }
    }
  });
}
if (!customElements.get('dtc-sticky-atc')) {
  customElements.define('dtc-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const hero = document.querySelector('[data-dtc-main-cta]');
      if (!hero) return;
      const button = this.querySelector('button');
      const sync = () => {
        this.querySelector('[data-sticky-price]').textContent = hero.querySelector('[data-price]').textContent;
        button.disabled = hero.disabled;
        button.textContent = hero.querySelector('span').textContent;
      };
      sync();
      this.mutation = new MutationObserver(sync);
      this.mutation.observe(hero, { attributes: true, childList: true, subtree: true, characterData: true });
      this.observer = new IntersectionObserver(([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting));
      this.observer.observe(hero);
      button.addEventListener('click', () => hero.click());
    }
    disconnectedCallback() { this.observer?.disconnect(); this.mutation?.disconnect(); }
  });
}
function initYunaGalleries(root=document){
root.querySelectorAll('[data-dtc-gallery]').forEach(gallery=>{
if(gallery.dataset.ready)return;
const surface=gallery.querySelector('.dtc-gallery__stage'),original=surface?.querySelector('img'),thumbs=[...gallery.querySelectorAll('[data-dtc-thumb]')];
if(!original||thumbs.length<2)return;gallery.dataset.ready='true';
surface.classList.add('yuna-swipe-gallery');
const slides=thumbs.map((thumb,i)=>{const img=i===0?original:original.cloneNode(false);img.removeAttribute('srcset');img.src=thumb.dataset.src;img.alt=thumb.dataset.alt||'';img.draggable=false;if(i){img.loading='lazy';img.removeAttribute('fetchpriority');surface.append(img);}return img;});
const prev=gallery.querySelector('[data-gallery-prev]'),next=gallery.querySelector('[data-gallery-next]');let index=0,drag=null,frame=0;
const state=()=>{index=Math.max(0,Math.min(slides.length-1,Math.round(surface.scrollLeft/surface.clientWidth)));thumbs.forEach((t,i)=>{t.classList.toggle('is-active',i===index);t.setAttribute('aria-pressed',String(i===index));});if(prev)prev.disabled=index===0;if(next)next.disabled=index===slides.length-1;const t=thumbs[index],rail=t.parentElement;rail.scrollTo({left:t.offsetLeft-rail.offsetLeft-(rail.clientWidth-t.clientWidth)/2,behavior:'smooth'});};
const show=i=>surface.scrollTo({left:Math.max(0,Math.min(slides.length-1,i))*surface.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
gallery.showImage=src=>{const i=thumbs.findIndex(t=>t.dataset.src.split('?')[0]===src.split('?')[0]);if(i>=0)show(i);};
thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));prev?.addEventListener('click',()=>show(index-1));next?.addEventListener('click',()=>show(index+1));
surface.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(state);},{passive:true});
surface.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button===0){drag={x:e.clientX,left:surface.scrollLeft};surface.classList.add('is-dragging');surface.setPointerCapture(e.pointerId);}});
surface.addEventListener('pointermove',e=>{if(drag)surface.scrollLeft=drag.left+drag.x-e.clientX;});
const end=()=>{if(!drag)return;drag=null;surface.classList.remove('is-dragging');show(Math.round(surface.scrollLeft/surface.clientWidth));};
surface.addEventListener('pointerup',end);surface.addEventListener('pointercancel',end);surface.addEventListener('dragstart',e=>e.preventDefault());
new ResizeObserver(()=>surface.scrollTo({left:index*surface.clientWidth,behavior:'instant'})).observe(surface);state();
});}
initYunaGalleries();document.addEventListener('shopify:section:load',e=>initYunaGalleries(e.target));
